const Project = (global.Project = {
  cognito: {
    region: 'eu-west-2',
    userPoolId: 'eu-west-2_dYBMkMeZc',
    userPoolWebClientId: '37kgb5k59d4njk22d6k913grr0',
  },
  cognitoMobile: {
    region: '',
    userPoolId: '',
    userPoolWebClientId: '',
  },
  debug: false,
  api: 'https://api-assess.mainstay.consulting/api/',
  ga: '',
  logs: {
    DATA: true,
    STORE: true,
    DISPATCHER: true,
    STORAGE: true,
    SERVER: true,
  },
  grecaptcher: '6Lc1mf4UAAAAAC6uZ0HaGJ3ufgwCXY4GFoNhMeBD',
  formly: 'boilerplate',
  mobile: {
    // Enabling secured storage for mobile requires installation of https://www.npmjs.com/package/react-native-secured-storage. See README for further instructions on installation
    useSecuredStorage: false,
  },
})
module.exports = Project
// if (typeof ENV_NAME !== 'undefined' && typeof ENV_TYPE !== 'undefined') {
// }
